import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Ambassador } from "../../../domain/entities/all-deliveries";
import { type AllDeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listAmbassadors = createAsyncThunk<
  Ambassador[],
  void,
  { dispatch: AllDeliveriesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_AMBASSADORS, async (_, { extra }) => {
  return await extra.allDeliveriesRepo.listAmbassadors();
});
